import { Button, Divider, Grid } from '@material-ui/core';
import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import Ws from '../../providers/Ws';


const AdaugaClientNou = (props) => {

    

  const  selectFile = (id) => {
        //  console.log('Incepe poza');
        let pi = document.getElementById(id);

        pi.click()
    }


  const  importClienti = (id) => {
        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);


        // console.log('this.state.luna :', this.state.luna);


        reader.onload = async () => {
            let fileContent = reader.result;
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadClient('Balanta/ImportRaportClientiLunar', saveFile, props.anul, 12);

            console.log('uploadImage :', uploadImage);
            if (uploadImage.Succes) {

                props.inapoi()
               
            }
        }
    }



    return (
        <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>



                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid container>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <div style={{ position: 'relative', textAlign: 'left' }}>
                                    <input
                                        style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                        id='localitate'
                                        type="text"
                                        step='any'
                                        className='add-project-input'
                                        placeholder={''}
                                        margin="normal"
                                        name='localitate'
                                        value={props.clientNume || ''}
                                        onChange={props.changeNumeClient}
                                    // onBlur={this.props.updateAngajatData}
                                    />
                                    <label className='inputLabelPM' htmlFor='telefon'>{props.dictionary.financiar.numeClient}</label>
                                </div>

                            </Grid>
                        </Grid>



                        <Divider style={{ marginBottom: 20, marginTop: 20 }} className='pm-divider' />
                    </Grid>


                    <Grid style={{ textAlign: 'left', paddingTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                        <Button
                            style={{ marginRight: 20 }}

                            className={'add-button-blue'} onClick={() => { props.addClient() }}  >

                            {props.dictionary.financiar.salveaza}
                        </Button>

                        <Button
                            style={{ marginRight: 20 }}

                            className={'inapoi-button-blue'} onClick={props.inapoi}  >

                            <i style={{
                                fontSize: 14,
                                marginRight: 10
                            }} className='material-icons'>keyboard_arrow_left</i>  {props.dictionary.financiar.inapoi}
                        </Button>
                    </Grid>


                    <Grid item style={{ textAlign: 'right', paddingTop: 20 }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                        <span
                            onClick={() => { this.setState({ openDownloadBilant: true }) }}
                            style={{
                                color: '#3e8ae6',
                                cursor: 'pointer',
                                display: 'block',
                                paddingTop: 10,
                                textDecoration: 'underline'
                            }}><i style={{ verticalAlign: 'sub', fontSize: 20 }} className='material-icons'>download</i> {props.dictionary.financiar.downloadTemplateClienti}</span>



                    </Grid>

                    <Grid item style={{ textAlign: 'right', paddingTop: 20 }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                        <input id="import-clienti" type="file" accept="file/*"
                            onChange={() => { importClienti('import-clienti') }}
                            style={{ display: 'none' }}
                        ></input>
                        <Button
                            style={{ marginRight: 20 }}

                            className={'add-button-blue'} onClick={() => { selectFile('import-clienti') }}  >

                            <i style={{
                                fontSize: 20,
                                marginRight: 10
                            }} className='material-icons'>upload_file</i>  {props.dictionary.financiar.importaClienti}
                        </Button>



                    </Grid>

                </Grid>
            </Grid>
        </Grid>
    );

}


export default AdaugaClientNou;